import React from 'react';
import { CHARTER_STATUS, endpoints } from './Constants';
import { encodeRequestBody } from './Helpers';

const submitCloneCharterRequest = ({ request, actions, fetch, alert, onCloseEditor }) => {
    const requestBody = encodeRequestBody(endpoints.cloneCharterRequest, JSON.stringify(request));

    return fetch(endpoints.cloneCharterRequest, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: requestBody
    }).then((response) => {
        if (response.status < 200 || response.status >= 300) {
            alert({ title: 'Submission Failed', body: response.body?.message || `Error: ${response.status}` });
            actions?.setSubmitting(false);
            return;
        }

        let alertBody = <h2>Please wait for us to confirm your charter, and then watch the offers roll in</h2>;
        let nextRoute = '/charterRequests/Me/New/';
        const result = response.body?.result;

        if (!result) {
            console.warn('Charter request clone returned 200 but no result object');
        } else if (result.status === CHARTER_STATUS.LIVE) {
            alertBody = <h2>Thank you for your charter enquiry. This request has been distributed accordingly, you will receive live updates as quotes are submitted.</h2>;
            nextRoute = '/charterRequests/Me/Live/';
        }

        alert({
            title: 'Submitted OK!',
            body: alertBody,
            onDismiss: () => onCloseEditor(nextRoute)
        });
        actions?.setSubmitting(false);
    }, (error) => {
        console.error('Charter clone network error:', error);
        alert({
            title: 'Submit failed!',
            body: <h2>Error occurred while submitting the request. Please contact Avmin support.</h2>
        });
        actions?.setSubmitting(false);
    });
}

export { submitCloneCharterRequest };